export const DEFAULT_PAGE_LIMIT = 50;
export const SEARCH_DEBOUNCE_TIME = 500;
export const PASSWORD_MIN_LENGTH = 8;
